import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5a96a4a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "modal__title" }, "Подтвердите действие", -1))
const _hoisted_4 = { class: "modal__field narrow" }
const _hoisted_5 = { class: "modal__field--text" }
const _hoisted_6 = { class: "modal__field" }
const _hoisted_7 = { class: "modal__field--action row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iconClose = _resolveComponent("iconClose")!
  const _component_QCard = _resolveComponent("QCard")!
  const _component_QDialog = _resolveComponent("QDialog")!

  return (_openBlock(), _createBlock(_component_QDialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isOpen) = $event)),
    onHide: _ctx.afterLeave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_QCard, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_iconClose, {
                class: "link gray-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn-link",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
                }, "Нет"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
                }, "Да")
              ])
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "onHide"]))
}